import { isApp } from '../others/devices'
import { windowLocation } from '../others/windowLocation'

export const GO_NATIVE_SET_USER_ID_URI = 'gonative://hublo/setUserId'
export const GO_NATIVE_SET_HUBLO_ID_URI = 'gonative://hublo/setHubloId'

export const setGoNativeUserId = (
  userId: string | null,
  hubloId: string | null,
) => {
  if (!isApp()) {
    return
  }

  windowLocation.assign(`${GO_NATIVE_SET_USER_ID_URI}?${userId}`)
  // We need to wait a bit before setting the hubloId to avoid window.location.assign to be overwritten
  setTimeout(() => {
    setGoNativeHubloId(hubloId)
  }, 500)
}

export const setGoNativeHubloId = (hubloId: string | null) => {
  if (!isApp()) {
    return
  }

  windowLocation.assign(`${GO_NATIVE_SET_HUBLO_ID_URI}?${hubloId}`)
}
